import "./styles/globals.css";
import { createRoot } from "react-dom/client";
import { HomePage } from "@/pages/home";

function start() {
	const rootElement = document.getElementById("root");
	if (!rootElement) throw new Error("Root element not found");

	createRoot(rootElement).render(<HomePage />);
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", start);
} else {
	start();
}
